document.addEventListener('alpine:init', () => {
  Alpine.store('cartCount', {
    count: (window.theme && window.theme.cartItemCount) || 0,
    init() {
      this._watchUpcart();
      window.addEventListener('baseline:cart:afteradditem', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      window.addEventListener('baseline:cart:cartqtychange', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });

      window.addEventListener('baseline:cart:update', (e) => {
        this._setFromFetchedSection(e.detail.response);
      });
    },
    // UpCart replaces the native drawer and does not dispatch Baseline events.
    // Watch its public header chunk, then read the authoritative Shopify count.
    _watchUpcart() {
      let lastTitle = null;
      let timer;
      const sync = () => {
        const title = document.querySelector('[data-upcart-chunk="header-title-content"]');
        const text = title ? title.textContent : null;
        if (text === lastTitle) return;
        lastTitle = text;
        clearTimeout(timer);
        timer = setTimeout(() => this._refreshCount(), 100);
      };
      new MutationObserver(sync).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      sync();
    },
    async _refreshCount() {
      try {
        const root = (window.Shopify && window.Shopify.routes.root) || '/';
        const response = await fetch(root + 'cart.js', { cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        this.count = cart.item_count;
        window.theme.cartItemCount = this.count;
      } catch (error) {
        // Keep the last known count if the cart request temporarily fails.
      }
    },
    _setFromFetchedSection(data) {
      const countSectionHTML = data.sections['cart-item-count'];

      this.count = parseInt(
        parseDOMFromString(countSectionHTML).firstElementChild.innerText.trim(),
        10
      );

      window.theme.cartItemCount = this.count;
    },
    countWithText() {
      let string = theme.strings.itemCountOther;

      if (this.count === 1) {
        string = theme.strings.itemCountOne;
      }

      return string.replace('{{ count }}', this.count);
    },
  });
});
